import { MaterialComponentCategory } from 'api';
import { MaterialSupportedComponentList } from 'features';
import {
  MaterialAutocomplete,
  MaterialColourAutocomplete,
  MaterialFormAutocomplete,
  MaterialGradeAutocomplete,
  TextField,
  useFormContext,
  useWatch,
} from 'form';
import { useTranslation } from 'i18n';
import { Divider, Stack, Typography } from 'ui';

import { BuyerMaterialSpecificationFormType } from '../../pages/schema';
import { DocumentSection } from '../DocumentSection/DocumentSection';
import { PackagingSpecificationList } from '../PackagingSpecificationList/PackagingSpecificationList';

export const BuyerMaterialSpecificationFormFields = () => {
  const { t } = useTranslation('orders');
  const form = useFormContext<BuyerMaterialSpecificationFormType>();
  const [material_id, material_colour_id] = useWatch({
    control: form.control,
    name: ['material_id', 'material_colour_id'],
  });

  return (
    <Stack spacing={3}>
      <Stack spacing={2}>
        <Typography variant="subtitle1" fontWeight="bold">
          {t('buyerMaterialSpecifications.form.sections.materialSpecifications')}
        </Typography>
        <MaterialAutocomplete
          name="material_id"
          label={t('buyerMaterialSpecifications.form.labels.material')}
          required
        />
        <MaterialFormAutocomplete
          name="material_form_id"
          label={t('buyerMaterialSpecifications.form.labels.materialForm')}
          required
        />
        <MaterialColourAutocomplete
          name="material_colour_id"
          label={t('buyerMaterialSpecifications.form.labels.materialColour')}
        />
        <MaterialGradeAutocomplete
          label={t('buyerMaterialSpecifications.form.labels.materialGrade')}
          name="material_grade_id"
          required
        />
      </Stack>
      <Divider />
      <MaterialSupportedComponentList
        materialId={material_id}
        materialColourId={material_colour_id}
        name="material_qualities"
        category={MaterialComponentCategory.MATERIAL_QUALITY}
      />
      <Divider />
      <PackagingSpecificationList />
      <Divider />
      <Stack
        spacing={2}
        sx={{
          marginBottom: 2,
        }}
      >
        <Typography variant="subtitle1" fontWeight="bold">
          {t('buyerMaterialSpecifications.form.sections.supportingInformation')}
        </Typography>
        <TextField label={t('buyerMaterialSpecifications.form.labels.notes')} name="notes" multiline />
        <DocumentSection />
      </Stack>
    </Stack>
  );
};
